
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import { sharedState } from '../../../../framework/state';
import EmailField from '../../../../framework/fields/EmailField.vue';
import DateField from '../../../../framework/fields/DateField.vue';
import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';
import { VehicleContractFillRequest } from '../../../../../common/application/model/VehicleContractFillRequest';
import TextField from '@/browser/framework/fields/TextField.vue';
import NumberField from '@/browser/framework/fields/NumberField.vue';
import SelectField from '@/browser/framework/fields/SelectField.vue';
import CurrencyAmountField from '@/browser/framework/fields/CurrencyAmountField.vue';
import PercentageField from '@/browser/framework/fields/PercentageField.vue';
import { getEnumerationOptions, OptionValue } from '../../../../../browser/framework/service/options';
import { VehicleType } from '../../../../../common/application/model/enums/VehicleType';
import { VehicleEnginePowerType } from '../../../../../common/application/model/enums/VehicleEnginePowerType';
import { VehicleElectricalClass } from '../../../../../common/application/model/enums/VehicleElectricalClass';
import { SpecialUseVehicleType } from '../../../../../common/application/model/enums/SpecialUseVehicleType';
import { getResource, getResources } from '../../../../../browser/framework/client/resource';
import { VehicleMake } from '../../../../../common/application/model/VehicleMake';

@Component({
    components: {
        PercentageField,
        CurrencyAmountField,
        SelectField,
        NumberField,
        TextField,
        DateField,
        EmailField,
        ValidationObserver,
    },
})
export default class VehicleContractFillRequestFieldsPreview extends Vue {
    readonly resourceType = ApplicationResource.SMART_FLEET_TASK;

    @Prop(Object) readonly vehicleContractFillRequest: VehicleContractFillRequest | undefined;

    shared = sharedState;
    local: {
        loading: boolean;
        row: VehicleContractFillRequest | null;
        vehicleTypeOptions: OptionValue[];
        vehicleMakeOptions: OptionValue[];
        vehicleEnginePowerTypeOptions: OptionValue[];
        vehicleElectricalClassOptions: OptionValue[];
        specialUseVehicleTypeOptions: OptionValue[];
    } = {
        loading: false,
        row: null,
        vehicleTypeOptions: [],
        vehicleMakeOptions: [],
        vehicleEnginePowerTypeOptions: [],
        vehicleElectricalClassOptions: [],
        specialUseVehicleTypeOptions: [],
    };

    async mounted() {
        await this.loadAsyncData();
    }

    private async loadAsyncData(): Promise<void> {
        this.local.loading = true;

        this.local = {
            ...this.local,
            row: this.vehicleContractFillRequest ?? null,
            vehicleTypeOptions: getEnumerationOptions('VehicleType', Object.keys(VehicleType), this),
            vehicleEnginePowerTypeOptions: getEnumerationOptions(
                'VehicleEnginePowerType',
                Object.keys(VehicleEnginePowerType),
                this,
            ),
            vehicleElectricalClassOptions: getEnumerationOptions(
                'VehicleElectricalClass',
                Object.keys(VehicleElectricalClass),
                this,
            ),
            specialUseVehicleTypeOptions: getEnumerationOptions(
                'SpecialUseVehicleType',
                Object.keys(SpecialUseVehicleType),
                this,
            ),
            vehicleMakeOptions: (await getResources<VehicleMake>(ApplicationResource.VEHICLE_MAKE)).map((x) => ({
                label: x.name,
                id: x.id,
            })),
            loading: false,
        };
    }
}
